import React, { useEffect, useState } from 'react'
import GetApi from '../../common/api/get'
import './search_form.scss'
import { loadPikadayIfNeeded } from "../../top/index/pikaday_loader"
import { countryPrefectureNames } from '../../common/constants/prefectures'

const prefecturesMaster = countryPrefectureNames('jp')

function addDays(date, days) {
  const daysInSeconds = days * 24 * 60 * 60 * 1000
  return new Date(date.getTime() + daysInSeconds)
}

function ymd(date) {
  const y = date.getFullYear()
  const m = ('0' + (date.getMonth() + 1)).slice(-2)
  const d = ('0' + date.getDate()).slice(-2)
  return `${y}-${m}-${d}`
}

const minCheckin = new Date()
const minCheckout = addDays(minCheckin, 1)
const maxCheckin = addDays(minCheckin, 365 * 2)
const maxCheckout = addDays(minCheckout, 365 * 2)

function SearchForm() {
  const [selectedPrefecture, setSelectedPrefecture] = useState(Object.keys(prefecturesMaster)[0])
  const [coupon, setCoupon] = useState(null)
  const [prefectures, setPrefectures] = useState([])

  const handlePrefectureChange = e => {
    setSelectedPrefecture(e.target.value)
  }

  useEffect(() => {
    loadPikadayIfNeeded()

    new GetApi().execute(routeUrlHelper.searchPath())
      .then(({ body: { available_coupons: coupons } }) => {
        setCoupon(coupons.find(({ title }) => title == '全国旅行支援'))
      })
  }, [])

  useEffect(() => {
    if (coupon) {
      new GetApi().execute(routeUrlHelper.searchPath({ coupon_id: coupon.id, count: 'prefectures' }))
        .then(({ body: { aggregations: { prefectures: { buckets = [] } = {} } } }) => {
          const prefectureKeys = buckets.map(({ key }) => key)

          const availablePrefectures = Object.entries(prefecturesMaster)
            .filter(([slug, name]) => (prefectureKeys.includes(slug)))
            .map(([slug, name]) => ({ slug, name }))

          setPrefectures(availablePrefectures)
          setSelectedPrefecture(availablePrefectures[0] && availablePrefectures[0].slug)
        })
    }
  }, [coupon])

  return (
    <div id="search-form" styleName="search-form-container">
      <form
        action={`/s/${selectedPrefecture}`}
        styleName="search-form "
        className="js-search-form"
        method="get"
        name="searchForm"
        data-bound="true">
        <div styleName="search-form-input-group">
          <div styleName="select-area">
            <label styleName="select-guests-label" htmlFor="country-select">都道府県</label>
            <div styleName="select-guests-wrap">
              <select
                id="country-select"
                aria-label="都道府県"
                styleName="adults-select"
                onChange={handlePrefectureChange} >
                {prefectures.map(({ name, slug }) => {
                  return <option value={slug} key={slug}>{name}</option>
                })}
              </select>
            </div>
          </div>

          <div styleName="date-range-container">
            <div styleName="date-range-input-container" className="js-date-range-input-container">
              <label styleName="date-range-label" htmlFor="checkin">チェックイン</label>
              <input aria-label="チェックイン"
                styleName="date-range-input" className="js-date-range-input"
                id="checkin" max={ymd(maxCheckin)}
                min={ymd(minCheckin)} name="checkin"
                placeholder="指定なし" type="date"
                autoComplete="off" />
            </div>
            <div styleName="date-range-input-container" className="js-date-range-input-container">
              <label styleName="date-range-label" htmlFor="checkout">チェックアウト</label>
              <input aria-label="チェックアウト"
                styleName="date-range-input"
                className="js-date-range-input"
                id="checkout" max={ymd(maxCheckout)}
                min={ymd(minCheckout)} name="checkout"
                placeholder="指定なし" type="date"
                autoComplete="off" />
            </div>
            <div styleName="pikaday-container" className="js-pikaday-container">
            </div>
          </div>

          <div styleName="select-guests">
            <label styleName="select-guests-label" htmlFor="adults">人数（2歳以上）</label>
            <div styleName="select-guests-wrap">
              <select aria-label="人数（2歳以上）" styleName="adults-select" id="adults" name="adults">
                { Array.from(Array(15)).map((_, i) =>
                  <option key={i} value={ i > 0 ? i + 1 : '' }>
                    { i + 1 }名
                  </option>)}
              </select>
            </div>
          </div>

          <div styleName="submit-btn">
            <button styleName="btn-primary" className="extended" type="submit" disabled={!coupon}>
              <span className="vs-icon-search"></span>
              <span styleName="btn-label">検索</span>
            </button>
          </div>

        </div>
        <input type="hidden" name="coupon_id" value={(coupon && coupon.id) || ""} />
      </form>
    </div>
  )
}

export default SearchForm
